import { ReactNode } from 'react';

import { Box, Container, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

type EmptyStateProps = {
  title?: string;
  description?: string;
  icon?: ReactNode;
  children?: ReactNode;
};

const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    userSelect: 'none',
    textAlign: 'center',
  },
}));

export default function EmptyState(props: EmptyStateProps) {
  const { title, description, icon, children } = props;
  const classes = useStyles();

  return (
    <Container className={classes.root} maxWidth="sm">
      <Box mb={(title || description) && icon ? 3 : 0}>{icon}</Box>

      {title && (
        <Typography variant="body2" gutterBottom>
          {title}
        </Typography>
      )}

      {description && (
        <Typography gutterBottom color="textSecondary" variant="caption">
          {description}
        </Typography>
      )}

      <Box mt={title || description || icon ? 3 : 0}>{children}</Box>
    </Container>
  );
}
